
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Component, HostListener, OnInit } from "@angular/core";

@Component({
  selector: "app-chatbot",
  templateUrl: "./chatbot.component.html",
  styleUrls: ["./chatbot.component.css"],
})
export class ChatbotComponent implements OnInit {
  showChatbot = false;
  chatbotUrl: SafeResourceUrl | null = null;
  isLoggedIn = false;
  isIframeLoading = true;
  iframeError: string | null = null;
  iframeErrorStatus: number | null = null;
  iframeScale = 1;
  pendingClearSession: boolean = false;
  chatbotDynamicUrl: string =
    location.href.includes("https://bedev.samvaadpro.com") ||
      location.href.includes("http://localhost")
      // ? "https://helpdesk-pro.dhanushinfotech.com/chatbot"
      // ? "https://helpdesk.kemis.go.ke/chatbot/enc"
      ? "https://kemis-helpdesk-pro.dhanushinfotech.com/chatbot/enc"
      : location.href.includes("https://kemis.go.ke")
        ? "https://helpdesk.kemis.go.ke/chatbot/enc"
        // ? "https://kemis-helpdesk-pro.dhanushinfotech.com/chatbot/enc"
        : "https://kemis-helpdesk-pro.dhanushinfotech.com/chatbot/enc";

  // chatbotDynamicUrl: string = "https://kemis-helpdesk-pro.dhanushinfotech.com/chatbot"   // dev
  // chatbotUrlPreprod: string = "https://kemis-helpdesk-pro.dhanushinfotech.com/chatbot"; // preprod

  // chatbotUrlProd: string = "https://helpdesk.kemis.go.ke/chatbot";
  // bedevUrl: string = "https://bedev.samvaadpro.com";

  // private loggedInUrl = `${this.chatbotUrldev}/signup/${this.useremail}/pass123/${this.name}/${254}${this.mobilenumber}`;

  private guestUrl = this.chatbotDynamicUrl.includes('/enc') ? this.chatbotDynamicUrl.split('/enc')[0]
    : this.chatbotDynamicUrl;
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.setChatbotUrl();
  }



  async setChatbotUrl() {
    this.chatbotUrl = null;
    this.iframeError = null;
    this.iframeErrorStatus = null;
    this.isIframeLoading = true;
    this.isLoggedIn = sessionStorage.getItem("isLogIn") === "true";

    const useremail = sessionStorage.getItem("USERNAME");
    const name = sessionStorage.getItem("FullName");
    const mobilenumber = localStorage.getItem("mobileno")?.trim();

    let url = '';

    if (this.isLoggedIn && useremail && name) {
      if (this.chatbotDynamicUrl.includes('/enc')) {
        const urls = "api/signup/" + useremail + "/pass123/" + name + "/254" + mobilenumber;
        const encUrl = await this.encryptWithKey(urls, 'chatbot@transport');
        url = `${this.chatbotDynamicUrl}/${encodeURIComponent(encUrl)}`;
      } else {
        const urls = "api/signup/" + useremail + "/pass123/" + name + "/254" + mobilenumber;
        url = `${this.chatbotDynamicUrl}/${urls}`;
      }
    } else {
      url = `${this.guestUrl}`;
    }

    // HEAD probe — checks server status without downloading the page body.
    // On success, the iframe loads the URL directly (one GET, no blob, assets work natively).
    try {
      const probe = await fetch(url, { method: 'GET' });
      if (!probe.ok) {
        this.iframeErrorStatus = probe.status;
        this.iframeError = probe.statusText || 'Service unavailable. Please try again later.';
        this.isIframeLoading = false;
        this.setIframeScale();
        return;
      }
    } catch (err) {
      console.error('Chatbot probe error:', err);
      this.iframeErrorStatus = 0;
      this.iframeError = 'Unable to connect to the helpdesk. Please check your connection and try again.';
      this.isIframeLoading = false;
      this.setIframeScale();
      return;
    }

    // Server is up — let the iframe load the URL directly
    this.chatbotUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.setIframeScale();
  }


  @HostListener("window:resize")
  onWindowResize() {
    this.setIframeScale();
  }


  setIframeScale() {
    const width = window.innerWidth;

    if (!this.isLoggedIn) {
      this.iframeScale = 1;
      return;
    }

    // Match React approach: use conservative scale based on viewport
    if (width < 480) {
      this.iframeScale = 0.68;
    } else if (width < 768) {
      this.iframeScale = 0.72;
    } else if (width < 1024) {
      this.iframeScale = 0.76;
    } else if (width < 1280) {
      this.iframeScale = 0.8;
    } else {
      this.iframeScale = 0.82;
    }
  }

  toggleChatbot() {
    if (!this.isLoggedIn) {
      this.pendingClearSession = true;
    } else {
      this.pendingClearSession = false;
    }
    if (!this.showChatbot) {
      this.setChatbotUrl(); // fetch latest session values
    }
    this.showChatbot = !this.showChatbot;
  }

  onIframeLoad() {
    this.isIframeLoading = false;

    if (!this.pendingClearSession) {
      return;
    }
    setTimeout(() => {
      const chatbotOrigin = this.chatbotDynamicUrl.replace("/chatbot", "");
      const iframe = document.getElementById(
        "chatbotFrame",
      ) as HTMLIFrameElement;

      iframe?.contentWindow?.postMessage(
        {
          action: "clearSession",
        },
        chatbotOrigin,
      );
      const params = new URLSearchParams(window.location.search);

      if (params.get("clearSession") === "true") {
        sessionStorage.removeItem("chatbot_user_context");
      }

      this.pendingClearSession = false;
    }, 1000);
  }

  encoder = new TextEncoder();
  padKey(key: any) {
    const keyBytes = this.encoder.encode(key);
    const paddedKeyBytes = new Uint8Array(32); // AES-256 key length (32 bytes)
    paddedKeyBytes.set(keyBytes.slice(0, Math.min(keyBytes.length, 32)), 0);
    return paddedKeyBytes;
  }
  async encryptWithKey(data: any, secretKey: any) {
    const dataString = typeof data === "string" ? data : JSON.stringify(data);
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const key = await crypto.subtle.importKey(
      "raw",
      this.padKey(secretKey),
      { name: "AES-GCM", length: 256 },
      false,
      ["encrypt"]
    );
    const encrypted = await crypto.subtle.encrypt(
      { name: "AES-GCM", iv, tagLength: 128 },
      key,
      this.encoder.encode(dataString)
    );
    const combined = new Uint8Array(iv.length + encrypted.byteLength);
    combined.set(iv, 0);
    combined.set(new Uint8Array(encrypted), iv.length);
    return btoa(String.fromCharCode(...combined));
  }





}